import { AxiosError } from 'axios';

export const errorInterceptor = (error: AxiosError) => {

  
  if (error.response?.status === 401 || error.response?.status === 400 || error.response?.status === 500 ) {
    if(error.response.data){
      return error.response;
    }
  }

  return Promise.reject(error);
};
